// polyfill
import '../polyfill/currentScript';

/*
  @odeniel recuperamos el script para tener la url base y carga el web worker:
*/

const src = document.currentScript.src; // con el polyfill va en ie11, sino: document.querySelector('script[src$="ec-form-builder-edicom.js"]').src
const workerUrl = src.replace(/\/([^\/]*)$/, '/ec-form-builder-edicom.worker.js'); // => .../ec-form-builder-edicom.worker.js

/*
  @odeniel este servicio sirve para transformar llamadas al web worker en promesas
  Las promesas deben añadirse aqui, como por ej. "validate"
  y declararse como "actions" del "worker.js"
*/

// Añadir las acciones aqui:
const actions = ['validate'];

export default function ecFormBuilderWorker() {
  let uuid = 0;
  const queue = {};
  let worker;

  function startWorker() {
    if (worker) {
      return;
    }
    worker = new Worker(workerUrl);
    worker.addEventListener(
      'message',
      ({ data: { id, data, error = '' } }) => {
        const { resolve, reject } = unregister(id);
        if (error) {
          return reject(error);
        }
        return resolve(data);
      },
      false
    );
  }

  /*
  Devolvemos un objeto con la lista de acciones cargadas arriba.
  ejemplo:
    return {
      validate: data => run('validate', data),
    };
  que se puede usar como:
    ecFormBuilderWorker.validate(data);
  */

  return actions.reduce((acc, cur) => {
    acc[cur] = data => run(cur, data);
    return acc;
  }, {});

  function register(id, resolve, reject) {
    queue[id] = { resolve, reject };
  }

  function unregister(id) {
    const { resolve, reject } = queue[id];
    delete queue[id];
    return { resolve, reject };
  }

  function run(action, data) {
    startWorker();
    const id = ++uuid;
    return new Promise((resolve, reject) => {
      register(id, resolve, reject);
      worker.postMessage({ action, data, id });
    });
  }
}
